"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypesPromo = void 0;
exports.TypesPromo = {
    config: "cross.config",
    component: "cross.component",
    random: "cross.randomized",
    randomComponent: "cross.randomGameConf"
};
//# sourceMappingURL=TypesPromo.js.map